import React, { useEffect } from "react";
import {
  ExpensesIcon,
  InventoryIcon,
  InvoiceIcon,
  ReportIcon,
} from "../../../assets/icons";
import { useReportStore } from "../../../state/useReportStore";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../state/useCompanyStore";
import { useSubscription } from "../../../context/SubscriptionProvider";


type UsageItemProps = {
  icon: React.ReactNode;
  label: string;
  used: number | undefined;
  limit: number | string | undefined;
};

const SubscriptionUsage = ({
  subscriptionState,
}: {
  subscriptionState: any | null;
  // subscriptionState: subscriptions | null;
}) => {
  const { t } = useTranslation("subscription");
  const userStore = useCompanyStore();
  const isRetail = userStore.isRetailBusiness();
  const { subscription: subscriptionData } = useSubscription();

  const UsageItem: React.FC<UsageItemProps> = ({
    icon,
    label,
    used = 0,
    limit,
  }) => {
    const displayLimit = limit === "infinite" ? "∞" : (limit ?? 0);

    return (
      <div className="flex justify-between">
        <span className="flex items-center gap-[10px]">
          {icon}
          {label}
        </span>
        {limit === "infinite" ? (
          <span>Unlimited</span>
        ) : (
          <span>
            {used ?? 0} out of {displayLimit}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="w-full lg:w-[72.4%]">
      <div className="md:border md:border-1 border-[#DFDFDF] rounded-[7px] flex gap-[30px] w-full  flex-col justify-between  md:pb-6 lg:pb-[35px] mt-[12px]">
        <p className="text-lg font-semibold  md:border-b  px-[2px] lg:px-[30px] mb-[-20px] md:py-3">
          {t("subscription.activeUsage")}
        </p>
        <div className="flex flex-col gap-[12px] lg:px-[30px] px-[12px] py-6 md:py-0 md:pt-0 md:border-none border border-[#DFDFDF] rounded-md md:rounded-none">
          <UsageItem
            icon={<ExpensesIcon />}
            label="Expenses"
            used={subscriptionData?.usage?.expenses}
            limit={subscriptionData?.limits?.expenses}
          />

          <UsageItem
            icon={<InvoiceIcon />}
            label="Invoices"
            used={subscriptionData?.usage?.invoices}
            limit={subscriptionData?.limits?.invoices}
          />

          <UsageItem
            icon={<ReportIcon />}
            label="Report"
            used={subscriptionData?.usage?.reports}
            limit={subscriptionData?.limits?.reports}
          />

          <UsageItem
            icon={<InventoryIcon />}
            label={isRetail ? "Inventories" : "Services"}
            used={
              isRetail
                ? subscriptionData?.usage?.inventories
                : subscriptionData?.usage?.services
            }
            limit={
              isRetail
                ? subscriptionData?.limits?.inventories
                : subscriptionData?.limits?.services
            }
          />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionUsage;
